import { render } from "./DividerCustom.vue?vue&type=template&id=f6bd67c6"
import script from "./DividerCustom.vue?vue&type=script&lang=js"
export * from "./DividerCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__